import { MySelector } from "../../redux/store"

const IndividualDownloadModal = () => {
  const {
    downloadData: { showModal, individualProgress },
  } = MySelector((state) => state.util)
  const { theme } = MySelector((state) => state.theme)

  if (!showModal) return null

  const { currentFile, totalFiles, currentFileProgress, currentFileName } = individualProgress

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className={`rounded-lg p-6 w-96 max-w-[90vw] ${
        theme === "dark"
          ? "bg-gray-800 text-white"
          : "bg-white text-gray-900"
      }`}>
        <div className="text-center mb-6">
          <h3 className="text-lg font-semibold mb-2">Downloading Files</h3>
          <p className="text-sm opacity-75">
            {currentFile > 0 ? `${currentFile} of ${totalFiles} files` : 'Preparing download...'}
          </p>
        </div>

        {currentFileName && (
          <div className="mb-4">
            <p className={`text-sm mb-2 ${theme === "dark" ? "text-gray-300" : "text-gray-600"}`}>
              Current file:
            </p>
            <p className="font-medium text-sm truncate">{currentFileName}</p>
          </div>
        )}

        <div className="space-y-4">
          {/* Overall Progress */}
          <div>
            <div className="flex justify-between text-sm mb-1">
              <span>Overall Progress</span>
              <span>{currentFile}/{totalFiles}</span>
            </div>
            <div className={`w-full rounded-full h-2 ${
              theme === "dark" ? "bg-gray-700" : "bg-gray-200"
            }`}>
              <div
                className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                style={{
                  width: totalFiles > 0 ? `${(currentFile / totalFiles) * 100}%` : '0%'
                }}
              />
            </div>
          </div>

          {/* Current File Progress */}
          {currentFile > 0 && (
            <div>
              <div className="flex justify-between text-sm mb-1">
                <span>Current File</span>
                <span>{currentFileProgress}%</span>
              </div>
              <div className={`w-full rounded-full h-2 ${
                theme === "dark" ? "bg-gray-700" : "bg-gray-200"
              }`}>
                <div
                  className="bg-green-600 h-2 rounded-full transition-all duration-300"
                  style={{ width: `${currentFileProgress}%` }}
                />
              </div>
            </div>
          )}
        </div>

        <div className={`mt-6 text-xs text-center ${
          theme === "dark" ? "text-gray-400" : "text-gray-500"
        }`}>
          Files will download automatically to your device
        </div>
      </div>
    </div>
  )
}

export default IndividualDownloadModal